// extracted by mini-css-extract-plugin
export default {"desktopWrapper":"Calculator_desktopWrapper__lVobi","mobileWrapper":"Calculator_mobileWrapper__yPh6+","container":"Calculator_container__l2iI1"};